import type { FeedbackMessages } from './en';

const de: FeedbackMessages = {
  qualified: {
    title: 'Vielen Dank für Ihre Teilnahme an dieser Studie!',
    body1: 'Sie können das Browserfenster nun schließen.',
    body2: 'Wir hoffen, Sie bald wiederzusehen.',
    refCode: 'Referenzcode: {code}',
  },
  quotaFull: {
    title: 'Diese Studie ist geschlossen',
    body1: 'Vielen Dank für Ihr Interesse an unserer Studie.',
    body2: 'Leider haben wir bereits alle benötigten Antworten erhalten.',
    body3: 'Wir hoffen, Sie in einer unserer zukünftigen Studien begrüßen zu dürfen!',
    refCode: 'Referenzcode: {code}',
  },
  terminated: {
    title: 'Vielen Dank für Ihr Feedback!',
    body1:
      'Wir hoffen, Sie bald in einer unserer zukünftigen Studien wiederzusehen. Bis dahin wünschen wir Ihnen einen schönen Tag.',
    body2: 'Bitte schließen Sie dieses Browserfenster.',
    refCode: 'Referenzcode: {code}',
  },
  mismatch: {
    title: 'Vielen Dank für Ihr Interesse',
    body1: 'Leider gehören Sie nicht zur Zielgruppe dieser speziellen Studie.',
    body2: 'Sie können diese Seite nun schließen.',
    code: 'Code: {code}',
  },
  error: {
    title: 'Wir können Ihre Anfrage derzeit nicht bearbeiten',
    linkProblemDetailed:
      'Bei dem von Ihnen aufgerufenen Link ist ein Problem aufgetreten. Bitte überprüfen Sie, ob der Link in der Adresszeile mit dem Ihnen mitgeteilten Link übereinstimmt, und versuchen Sie es erneut.',
    linkProblemGeneric:
      'Bei dem von Ihnen aufgerufenen Link ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.',
    contactPerson:
      'Sollte das Problem weiterhin bestehen, informieren Sie bitte die Person, von der Sie den Link erhalten haben, über dieses Problem.',
    errorCode: 'Fehlercode: {code}',
  },
};

export default de;
